import React from 'react';

import SaveAltIcon from '@material-ui/icons/SaveAlt';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';

import { CsvBuilder } from 'filefy';


const ReportToolbar = (props) => {
    const { data } = props;

    const csvExport = () => {
        const csvBuilder = new CsvBuilder(data.filename || 'export.csv')
            .setColumns(data.columns)
            .addRows(data.rows)
            .exportFile();
    }

    return (
        <Tooltip title="Export to CSV">
            <IconButton onClick={csvExport}><SaveAltIcon /></IconButton>
        </Tooltip>
    )
};

export default ReportToolbar;
